import { render, staticRenderFns } from "./gifts-product.vue?vue&type=template&id=1f199aa7&"
import script from "./gifts-product.vue?vue&type=script&lang=js&"
export * from "./gifts-product.vue?vue&type=script&lang=js&"
import style0 from "./gifts-product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceholderImg: require('/opt/build/repo/storefront/components/legacy/global/placeholder-img.vue').default,DynamicImg: require('/opt/build/repo/storefront/components/legacy/global/dynamic-img.vue').default,SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,BestsellerButtons: require('/opt/build/repo/storefront/components/legacy/global/bestseller-buttons.vue').default})
